import bdServicesExt from '../bd-servicesExt'
import bdServices from '../bd-services'
import bdServices125 from '../bd-services125'
var FormData = require('form-data')

const videoServices = {}

videoServices.post = async function (video) { 
  const { nombre, email, nombreArchivo, archivo, puesto, centroTrabajo } = video

  let formData = new FormData()
  formData.append('nombre', nombre)
  formData.append('email', email)
  formData.append('puesto', puesto)
  formData.append('centroTrabajo', centroTrabajo)
  formData.append('nombreArchivo', nombreArchivo)
  formData.append('file', archivo)
  console.log(formData)
  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/ductertube/crud/addVideo.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

videoServices.get = async function() {
  const data = bdServices.get('/servidores/ductertube/crud/getVideos.php')
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

export default videoServices


// WEBPACK FOOTER //
// ./src/services/videos/index.js